import WhatsNewShow from './WhatsNewShow'

export default WhatsNewShow
